import { cryptoCurrenciesMarketSelector } from 'components/features/rewards/rewardsPane/store/selectors/currencies'
import { SimpleGuard } from 'interfaces/guards'
import { CurrenciesMetaGetMarketDataRequestAction } from 'components/features/rewards/rewardsPane/store/actions/currenciesStatistics'
import { Collection } from 'interfaces'
import { CryptoCurrencyStatistics } from 'components/features/rewards/rewardsPane/types/cryptoCurrency'

export const cryptoMarketGuard: SimpleGuard = {
  name: `Crypto Market Data Loaded Guard`,
  checker: (state): boolean => {
    const cryptoMarketData: Collection<CryptoCurrencyStatistics, 'id'> | null = cryptoCurrenciesMarketSelector(state)
    return Boolean(cryptoMarketData?.allKeys.length)
  },
  loader: (dispatch) => {
    dispatch(new CurrenciesMetaGetMarketDataRequestAction())
  },
}
